import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { SetCustomFilterValue } from "./request";
import { SetCustomFilterValueHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapSetCustomFilterValue = (broker: BrokerExtensions) => {
  request = broker.registerRequest(SetCustomFilterValue, SetCustomFilterValueHandler);
};

export const teardownSetCustomFilterValue = () => {
  request?.dispose();
};
